document.addEventListener('DOMContentLoaded', function() {
   let container = document.querySelector('.product-fastbundle')

    if (container != null) {
        const observer = new MutationObserver(function(mutations) {
            const rbrContainer = document.getElementById('rbr-container-element-true');
            const productForm = document.querySelector('product-form .product-form');

            if (rbrContainer && productForm) {
                productForm.appendChild(rbrContainer);
                observer.disconnect();
              
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }
});


